module.exports = __webpack_public_path__ + "img/New PACI Flow - New User AR - 6.f4cec69d.png";